import { FC } from 'react'
import { compact } from 'lodash'
import LineFields from '@templates/AddNewItemModal/Content/LineFields'
import { Field } from '@templates/AddNewItemModal/Content'
import { dateField, textField } from '@templates/AddNewItemModal/templates'
import RiskMapFileField from '@templates/RiskMapFileField'
import { ExternalLineWrapper } from '@templates/AddNewItemModal/Content/LineFields/styled'
import RiskMapStatuses from '@enums/RiskMapStatuses'

const getFirstLine = (
  isEdit: boolean,
  status: RiskMapStatuses | undefined
): Field[] =>
  compact([
    textField({
      label: 'Номер карты рисков',
      isRequired: true,
      name: 'number',
      placeholder: 'Номер карты рисков',
    }),
    dateField({
      label: 'Пересмотреть до',
      name: 'reviseBeforeAt',
    }),
    isEdit &&
      status === RiskMapStatuses.APPROVED &&
      dateField({
        label: 'Дата утверждения',
        name: 'approvedAt',
      }),
  ])

type Props = {
  fileDisabled: boolean
  status: RiskMapStatuses | undefined
  isEdit: boolean
}

const InfoFields: FC<Props> = ({ fileDisabled, status, isEdit }) => {
  return (
    <>
      <ExternalLineWrapper id="risk-map-info">
        <LineFields
          fields={getFirstLine(isEdit, status)}
          lineTitle="Информация о карте рисков"
        />
      </ExternalLineWrapper>
      <RiskMapFileField isDisabled={fileDisabled} />
    </>
  )
}

export default InfoFields
